export const CREATE_FOLDER = "CREATE_FOLDER";
export const CLEAR_FOLDER = "CLEAR_FOLDER";
export const GET_FOLDERS = "GET_FOLDERS";
export const GET_PICTURES = "GET_PICTURES";
export const QUOTE_REQUESTED = "QUOTE_REQUESTED";
export const QUOTE_RECEIVED = "QUOTE_RECEIVED";
export const QUOTE_FAILED = "QUOTE_FAILED";
export const CLEAR_URL = "CLEAR_URL";
export const SET_PATH = "SET_PATH";

export const QUOTES_REQUESTED = "QUOTES_REQUESTED";
export const QUOTES_RECEIVED = "QUOTES_RECEIVED";
export const QUOTES_FAILED = "QUOTES_FAILED";
export const CLEAR_URLS = "CLEAR_URLS";
